import { render, staticRenderFns } from "./LabText.vue?vue&type=template&id=0c0c5e5a&"
import script from "./LabText.vue?vue&type=script&lang=js&"
export * from "./LabText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports